module.exports = __webpack_public_path__ + "static/img/active7.72c89709.png";